import tableColumnsCache from "@/utils/tableColumnsCache"

const listVersion = 1
export const listName = 'sl.website.blog.categoria'
export const listStorage = tableColumnsCache(listName, [
    {label: 'ID', name: 'id', active: true, sortable: true, ordering: 1},
    {label: 'Nome', name: 'name', active: true, sortable: true, ordering: 2},
    {label: 'Ativo', name: 'status', active: true, sortable: true, ordering: 3},
], listVersion)
